import { apiGet, apiPost, apiPatch, apiDelete } from './client'

export async function getAllContent(token: string) {
  return apiGet('/admin/content/all', token)
}

export async function createContent(token: string, data: any) {
  return apiPost('/admin/content/create', token, data)
}

export async function updateContent(token: string, id: string, data: any) {
  return apiPatch(`/admin/content/${id}`, token, data)
}

export async function deleteContent(token: string, id: string) {
  return apiDelete(`/admin/content/${id}`, token)
}
